import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FileComplainService } from './file-complain.service';
import { Router } from '@angular/router'
import { S3Service } from './s3.service';
import * as moment from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';

@Component({
  selector: 'app-standard',
  templateUrl: './file-complain.component.html',
  styles: []
})
export class FileComplainComponent implements OnInit {

  @BlockUI('attachment-list') blockUI: NgBlockUI;
  @BlockUI('image-list') block: NgBlockUI;
  selectedFiles: FileList;
  selectedVideos: FileList;
  selectedPdf: FileList;
  public max = new Date();
  images: any;
  videos: any;
  attachment: any;
  categories: any;
  Images: any;
  PDF: any;
  userFirstName: any;
  userTertiary: any;
  userLastName: any;
  annonymousName: any;
  mobileNumber: any;
  Test: any
  disabled: boolean;
  complaintData: any = {
    Category: '',
    crime_details: '',
    images: [],
    videos: [],
    first_name: '',
    last_name: '',
    victims_count: 1,
    phone_number: '',
    submitted_by: '',
    email: '',
    lat: 0,
    long: 0,
    address: '',
    attachment: '',
    incident_date: '',
    state: '',
    lga: '',
    age: ''
  };
  type: any;
  decrypted: any;
  userEmail: string;
  states: any;
  stateId: any = null;
  lgas: any;
  isChecked: boolean;
  disableButton: boolean = false;
  isRadioChecked: boolean = false;

  constructor(
    private fileComplainService: FileComplainService,
    private uploadService: S3Service,
    private router: Router,
    private toastr: ToastrService) {
  }

  ngOnInit() {
    this.fileComplainService.getState().subscribe(res => {
      this.states = res.data
      console.log('STATES', res)
    })
    this.categories = this.fileComplainService.categories
    // this.decrypted = this.fileComplainService.DecryptData
    this.disabled = true;
    this.userFirstName = localStorage.getItem('first')
    this.userLastName = localStorage.getItem('last')
    this.annonymousName = localStorage.getItem('annonymous')
    this.mobileNumber = localStorage.getItem('mobile')
    this.type = localStorage.getItem('scope')

    this.userEmail = localStorage.getItem('user_email')

  }
  ngOnDestroy() {
    this.block.stop(); // Stop blocking
  }
  trimTertiaryName(ev) {
    if (this.complaintData.submitted_by == 'Myself') {
      this.userTertiary = ev.target.value.trim();
      // this.complaintData.tertiary = '';
    } else {
      this.complaintData.tertiary = ev.target.value.trim();
      // this.userTertiary = '';
    }
  }
  trimFirstName(ev) {
    if (this.complaintData.submitted_by == 'Myself') {
      this.userFirstName = ev.target.value.trim();
      // this.complaintData.first_name = '';
    } else {
      this.complaintData.first_name = ev.target.value.trim();
      console.log('firstNameForSomeoneElse',  this.complaintData.first_name);
      
      // this.userFirstName = '';
    }
  }
  trimLastName(ev) {
    if (this.complaintData.submitted_by == 'Myself') {
      this.userLastName = ev.target.value.trim();
      // this.complaintData.last_name = '';
    } else {
      this.complaintData.last_name = ev.target.value.trim();
      // this.userLastName = '';
    }
  }
  trimAnnonymousName(ev) {
    if (this.complaintData.submitted_by == 'Myself') {
      this.annonymousName = ev.target.value.trim();
      // this.complaintData.annonymous_name = '';
    } else {
      this.complaintData.annonymous_name = ev.target.value.trim();
      // this.annonymousName = '';
    }
  }
  trimAddress(ev) {
    this.complaintData.address = ev.target.value.trim();
  }
  trimCaseDetails(ev) {
    this.complaintData.crime_details = ev.target.value.trim();
  }
  test(data): void {
    this.Test = data
  }
  check(val) {
    if (val == 'yes') {
      this.isRadioChecked = true;
    } else {
      this.isRadioChecked = false;
    }
  }
  submit(data) {
    this.disableButton = true;
    if (data.first_name == "" && this.Test == "Myself") {
      this.complaintData.first_name = localStorage.getItem('first')
      this.complaintData.last_name = localStorage.getItem('last')
      this.complaintData.phone_number = localStorage.getItem('mobile')
      this.complaintData.annonymousName = localStorage.getItem('annonymous')
      this.complaintData.email = localStorage.getItem('user_email')
    }
    console.log('data', data)
    // data.incident_date = moment().format("YYYY-MM-DD HH:mm")
    console.log(">>>>>>>data", moment.utc(data.incident_date).format())
    data.incident_date = moment.utc(data.incident_date).format()
    console.log('data in save', data)
    this.fileComplainService.saveComplain(data).then(() => {
      this.toastr.success('Your case was submitted successfully!');
      this.router.navigate(['/my-complains']);
      this.disableButton = false;
    }, (error) => {
      console.log('fail callback', error.status)
        this.toastr.error(error.error.message);
        this.disableButton = false;
    }).catch(e => {
      console.log('catch', e);
    });
  }

  selectFile(event) {
    this.block.start(); // Start blocking
    this.selectedFiles = event.target.files;
    let file = this.selectedFiles.item(0);
    if (!file) {
      setTimeout(() => {
        this.block.stop(); // Stop blocking
      }, 2000);
    }
    else if (file && file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
      this.uploadService.uploadfile(file).then((url) => {
        console.log('uploaded_image********', url);
        
        this.Images = url.Location
        this.block.stop(); // Stop blocking
        const str = url.key
        const res = str.split("/");
        const file_name = res[res.length - 1];
        this.complaintData.images.push(file_name)
      })
    } else {
      this.toastr.error('Only .jpeg, .jpg and .png files are allowed');
      setTimeout(() => {
        this.block.stop(); // Stop blocking
      }, 2000);
    }
  }




  selectVideo(event) {
    this.selectedVideos = event.target.files;
    const video = this.selectedVideos.item(0);
    this.uploadService.uploadVideo(video).then((url) => {
      console.log(';url in selectVideo', url)
      const videoStr = url.key
      const resVideo = videoStr.split("/");
      const video_name = resVideo[resVideo.length - 1];
      this.complaintData.videos.push(video_name)
    })
  }

  selectPdf(event) {
    this.selectedPdf = event.target.files;
    console.log('selectedPdf', this.selectedPdf)
    const pdf = this.selectedPdf.item(0);
    this.uploadService.uploadPdf(pdf).then((url) => {
      this.blockUI.start(); // Start blocking
      console.log(';url in selectVideo', url)
      this.PDF = url.Location
      const pdfStr = url.key
      const resPdf = pdfStr.split("/");
      const attachment_name = resPdf[resPdf.length - 1];
      // this.complaintData.attachment.push(attachment_name)
      this.complaintData.attachment = attachment_name
      console.log('through service', this.uploadService.attachemnetName)

      this.PDF = this.uploadService.attachemnetName
      setTimeout(() => {
        this.blockUI.stop(); // Stop blocking
      }, 2000);
    })
  }

  getLga(stateId) {
    console.log("On Change", stateId);
    this.fileComplainService.getLga(stateId).then(res => {
      this.lgas = res.data
      console.log('LGAS', res)
    })
  }
}
